var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterHandsUp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 147,
    viewBox: "0 0 173 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14011_164662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.206 7.89093C154.097 2.0422 151.772 27.5914 139.673 56.7028C127.433 86.1478 126.839 86.3687 137.16 95.8949C153.43 110.911 173.944 16.3596 162.206 7.89093Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.308 12.2729C155.661 6.95284 152.913 28.8765 142.917 53.5273C132.81 78.4611 132.368 78.6296 139.468 87.1932C150.663 100.697 169.482 19.9765 161.308 12.2729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80991 7.89093C14.9185 2.0422 17.2441 27.5914 29.3431 56.7028C41.5826 86.1478 42.1763 86.3687 31.8561 95.8949C15.5856 110.911 -4.92857 16.3596 6.80991 7.89093Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.7081 12.2729C13.3549 6.95284 16.1026 28.8765 26.0987 53.5273C36.206 78.4611 36.648 78.6296 29.548 87.1932C18.3529 100.697 -0.46616 19.9765 7.7081 12.2729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.597 99.3227C144.597 66.9972 118.256 30.9209 85.7587 30.9209C53.264 30.9209 26.9219 66.9972 26.9219 99.3227C26.9219 121.707 39.554 143.903 58.1147 146.908C66.3572 148.243 75.7665 134.663 85.7587 134.663C96.3579 134.663 106.301 148.207 114.891 146.653C118.145 146.064 121.204 144.832 124.03 143.081C136.619 135.27 144.597 117.111 144.597 99.3227Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6943 25.712C26.9644 26.3027 27.3079 26.9022 27.6921 27.506C27.6888 27.5082 27.6866 27.5093 27.6822 27.5104C37.1454 43.4416 49.525 55.6101 63.1967 55.6101C73.4018 55.6101 83.023 48.981 91.1381 38.933C89.2029 35.2085 81.7277 24.2247 73.8211 20.5657C76.0472 23.2584 76.7102 24.097 77.7333 26.9709C69.0221 22.2298 56.5513 18.3644 43.9993 20.7011C53.5403 21.5233 55.7675 23.6187 57.5721 25.1736C52.3065 25.2839 41.8391 20.1213 29.7635 23.6864C31.6306 23.7094 39.2782 23.6788 41.3835 25.5121C40.411 25.8484 30.0423 23.6078 26.6943 25.712Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2196 35.9668C28.7969 36.1098 29.393 36.314 30.0022 36.5564C30.0044 36.5532 30.0044 36.551 30.0055 36.5488C45.9417 42.3076 58.9778 51.2986 61.2708 63.4845C62.9832 72.5781 58.6265 82.2668 50.9394 91.1835C47.26 90.0818 36.113 85.2631 31.4907 78.8316C34.2908 80.3647 35.1558 80.8135 37.9165 81.2426C32.1855 74.275 26.6114 63.8099 26.6104 52.23C28.9517 60.5964 31.2118 62.2288 32.9165 63.5773C32.1306 58.8668 25.7256 50.4032 26.9111 39.0428C27.2448 40.7036 28.4995 47.5238 30.5049 49.0929C30.6432 48.1691 26.8859 39.3037 28.2196 35.9668Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.826 25.712C144.555 26.3027 144.21 26.9022 143.827 27.506C143.829 27.5082 143.834 27.5093 143.837 27.5104C134.375 43.4416 121.995 55.6101 108.324 55.6101C98.1184 55.6101 88.4961 48.981 80.3799 38.933C82.3173 35.2085 89.7925 24.2247 97.698 20.5657C95.4708 23.2584 94.81 24.097 93.787 26.9709C102.498 22.2298 114.969 18.3644 127.521 20.7011C117.98 21.5233 115.753 23.6187 113.947 25.1736C119.211 25.2839 129.68 20.1213 141.757 23.6864C139.89 23.7094 132.241 23.6788 130.137 25.5121C131.109 25.8484 141.477 23.6078 144.826 25.712Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.3 35.9668C142.723 36.1098 142.126 36.314 141.519 36.5564C141.517 36.5532 141.517 36.551 141.515 36.5488C125.579 42.3076 112.544 51.2986 110.251 63.4845C108.537 72.5781 112.894 82.2668 120.582 91.1835C124.26 90.0818 135.408 85.2631 140.03 78.8316C137.23 80.3647 136.366 80.8135 133.603 81.2426C139.336 74.275 144.908 63.8099 144.91 52.23C142.57 60.5964 140.309 62.2288 138.605 63.5773C139.389 58.8668 145.796 50.4032 144.61 39.0428C144.277 40.7036 143.022 47.5238 141.017 49.0929C140.875 48.1691 144.635 39.3037 143.3 35.9668Z",
    fill: "#FF122F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.163 67.9044C130.365 63.4886 131.911 58.3729 131.911 52.9482C130.058 59.5708 128.269 60.8625 126.919 61.9294C127.541 58.2015 132.612 51.5025 131.673 42.5127C131.408 43.8262 130.415 49.2237 128.828 50.4663C128.719 49.7347 131.693 42.7179 130.639 40.0766C130.18 40.1901 129.707 40.3528 129.225 40.5439V40.5373C127.791 41.0549 126.388 41.6053 125.024 42.1883C127.169 39.5109 129.187 36.5409 131.062 33.3841C131.058 33.383 131.058 33.3819 131.055 33.3808C131.36 32.9026 131.631 32.4287 131.845 31.9613C129.194 30.295 120.988 32.0683 120.218 31.803C121.883 30.3507 127.938 30.3758 129.416 30.3595C119.858 27.5357 111.573 31.6228 107.406 31.5355C108.835 30.3038 110.596 28.6451 118.149 27.9954C108.214 26.1457 98.3426 29.2053 91.4481 32.9572C92.2603 30.6838 92.7828 30.0199 94.5457 27.8873C91.0529 29.5034 87.6731 32.92 85.0969 36.1401C82.5195 32.92 79.1365 29.5034 75.6458 27.8873C77.4076 30.0199 77.9323 30.6838 78.7424 32.9572C71.8479 29.2053 61.9775 26.1457 52.0402 27.9954C59.5944 28.6451 61.3562 30.3038 62.7865 31.5355C58.6186 31.6228 50.3322 27.5357 40.7758 30.3595C42.2533 30.3758 48.3059 30.3507 49.9733 31.803C49.2016 32.0683 40.9953 30.295 38.3466 31.9613C38.5596 32.4287 38.8318 32.9026 39.1369 33.3808C39.1348 33.3819 39.1326 33.383 39.1293 33.3841C41.0041 36.5409 43.0227 39.5109 45.1665 42.1883C43.8021 41.6053 42.3993 41.0549 40.9668 40.5373C40.9657 40.5384 40.9657 40.5406 40.9657 40.5439C40.4827 40.3528 40.0107 40.1901 39.5541 40.0766C38.4981 42.7179 41.4717 49.7347 41.363 50.4663C39.7758 49.2237 38.7824 43.8262 38.5168 42.5127C37.5804 51.5025 42.6506 58.2015 43.2708 61.9294C41.9229 60.8625 40.1336 59.5708 38.2797 52.9482C38.2797 58.8872 40.1336 64.455 42.6715 69.1394C36.879 79.8053 33.4883 92.0142 33.4883 103.629C33.4883 134.142 56.8908 132.435 85.7599 132.435C114.63 132.435 138.033 134.142 138.033 103.629C138.033 91.5632 134.372 78.8575 128.163 67.9044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.9,
    cx: 87.2653,
    cy: 92.2127,
    rx: 54.21,
    ry: 33.5809,
    fill: "url(#paint0_radial_14011_164662)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.62 102.282C133.62 107.702 129.203 112.098 123.753 112.098H48.6659C43.2159 112.098 38.7988 107.702 38.7988 102.282C38.7988 96.8618 43.2159 92.4668 48.6659 92.4668H123.753C129.203 92.4668 133.62 96.8618 133.62 102.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0234 66.9779C82.0234 76.1589 74.5438 83.6025 65.3145 83.6025C56.0842 83.6025 48.6035 76.1589 48.6035 66.9779C48.6035 57.7959 56.0842 50.3533 65.3145 50.3533C74.5438 50.3533 82.0234 57.7959 82.0234 66.9779Z",
    fill: "#DA4854"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9435 66.9772C80.9435 75.5639 73.9459 82.5248 65.314 82.5248C56.6821 82.5248 49.6846 75.5639 49.6846 66.9772C49.6846 58.3906 56.6821 51.4297 65.314 51.4297C73.9459 51.4297 80.9435 58.3906 80.9435 66.9772Z",
    fill: "url(#paint1_radial_14011_164662)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7233 66.9782C73.7233 71.5975 69.9589 75.3422 65.3153 75.3422C60.6716 75.3422 56.9072 71.5975 56.9072 66.9782C56.9072 62.3589 60.6716 58.6143 65.3153 58.6143C69.9589 58.6143 73.7233 62.3589 73.7233 66.9782Z",
    fill: "url(#paint2_radial_14011_164662)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2471 66.9782C69.2471 69.1392 67.4864 70.8906 65.3152 70.8906C63.1418 70.8906 61.3811 69.1392 61.3811 66.9782C61.3811 64.8173 63.1418 63.0659 65.3152 63.0659C67.4864 63.0659 69.2471 64.8173 69.2471 66.9782Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.3099,
    cy: 62.8661,
    rx: 4.68,
    ry: 3.59655,
    fill: "url(#paint3_radial_14011_164662)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.916 66.9778C122.916 76.1598 115.436 83.6035 106.204 83.6035C96.9745 83.6035 89.4938 76.1598 89.4938 66.9778C89.4938 57.7957 96.9745 50.3531 106.204 50.3531C115.436 50.3531 122.916 57.7957 122.916 66.9778Z",
    fill: "#DA4854"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.835 66.9777C121.835 75.5646 114.837 82.5257 106.205 82.5257C97.5729 82.5257 90.5752 75.5646 90.5752 66.9777C90.5752 58.3908 97.5729 51.4297 106.205 51.4297C114.837 51.4297 121.835 58.3908 121.835 66.9777Z",
    fill: "url(#paint4_radial_14011_164662)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.614 66.9773C114.614 71.5966 110.85 75.3412 106.206 75.3412C101.562 75.3412 97.7979 71.5966 97.7979 66.9773C97.7979 62.358 101.562 58.6133 106.206 58.6133C110.85 58.6133 114.614 62.358 114.614 66.9773Z",
    fill: "url(#paint5_radial_14011_164662)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.137 66.9771C110.137 69.1392 108.376 70.8906 106.205 70.8906C104.032 70.8906 102.273 69.1392 102.273 66.9771C102.273 64.8162 104.032 63.0648 106.205 63.0648C108.376 63.0648 110.137 64.8162 110.137 66.9771Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.2,
    cy: 62.8661,
    rx: 4.68,
    ry: 3.59655,
    fill: "url(#paint6_radial_14011_164662)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6589 92.0119C43.2217 92.0119 38.8064 96.4243 38.8064 101.833C38.8064 107.262 43.2217 111.654 48.6589 111.654H123.759C129.196 111.654 133.611 107.262 133.611 101.833C133.611 96.4243 129.196 92.0119 123.759 92.0119H48.6589Z",
    fill: "url(#paint7_linear_14011_164662)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9941 92.0225V93.6582C47.9941 95.1377 49.2005 96.3399 50.6879 96.3399C52.1774 96.3399 53.3827 95.1377 53.3827 93.6582V92.0225H47.9941Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.415 92.0234V93.4036C48.415 94.6506 49.4326 95.6628 50.6872 95.6628C51.943 95.6628 52.9606 94.6506 52.9606 93.4036V92.0234H48.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38853,
    height: 1.57784,
    transform: "matrix(-1 0 0 1 53.3799 92.0215)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0734 92.0225C55.0734 92.0257 55.0723 92.0323 55.0723 92.0367V93.6582C55.0723 95.1377 56.2797 96.3399 57.7671 96.3399C59.2544 96.3399 60.4618 95.1377 60.4618 93.6582V92.0367C60.4618 92.0323 60.4607 92.0257 60.4607 92.0225H55.0734Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4961 92.0234V93.4036C55.4961 94.6506 56.5125 95.6628 57.7672 95.6628C59.0218 95.6628 60.0404 94.6506 60.0404 93.4036V92.0234H55.4961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38846,
    height: 1.57784,
    transform: "matrix(-1 0 0 1 60.4619 92.0215)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1504 92.0225V93.6582C62.1504 95.1377 63.3568 96.3399 64.8463 96.3399C66.3337 96.3399 67.54 95.1377 67.54 93.6582V92.0225H62.1504Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5753 92.0234C62.5742 92.0267 62.5742 92.0311 62.5742 92.0354V93.4036C62.5742 94.6506 63.5918 95.6628 64.8464 95.6628C66.1011 95.6628 67.1186 94.6506 67.1186 93.4036V92.0354C67.1186 92.0311 67.1175 92.0267 67.1175 92.0234H62.5753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38966,
    height: 1.57675,
    transform: "matrix(1 0 0 -1 62.1504 93.5996)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2305 92.0225V93.6582C69.2305 95.1377 70.4368 96.3399 71.9264 96.3399C73.4137 96.3399 74.62 95.1377 74.62 93.6582V92.0225H69.2305Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6523 92.0234V93.4036C69.6523 94.6506 70.6699 95.6628 71.9257 95.6628C73.1804 95.6628 74.1979 94.6506 74.1979 93.4036V92.0234H69.6523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38958,
    height: 1.57675,
    transform: "matrix(1 0 0 -1 69.2295 93.5996)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3096 92.0225V93.6582C76.3096 95.1377 77.5159 96.3399 79.0033 96.3399C80.4928 96.3399 81.6981 95.1377 81.6981 93.6582V92.0225H76.3096Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7314 92.0234V93.4036C76.7314 94.6506 77.749 95.6628 79.0036 95.6628C80.2594 95.6628 81.2769 94.6506 81.2769 93.4036V92.0234H76.7314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38853,
    height: 1.57675,
    transform: "matrix(1 0 0 -1 76.3105 93.5996)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3889 92.0225C83.3889 92.0257 83.3867 92.0323 83.3867 92.0367V93.6582C83.3867 95.1377 84.5953 96.3399 86.0815 96.3399C87.5722 96.3399 88.7774 95.1377 88.7774 93.6582V92.0225H83.3889Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8118 92.0234C83.8118 92.0267 83.8096 92.0311 83.8096 92.0354V93.4036C83.8096 94.6506 84.8282 95.6628 86.0818 95.6628C87.3386 95.6628 88.3561 94.6506 88.3561 93.4036V92.0234H83.8118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38853,
    height: 1.57784,
    transform: "matrix(-1 0 0 1 88.7754 92.0215)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4668 92.0225V93.6582C90.4668 95.1377 91.6731 96.3399 93.1627 96.3399C94.6501 96.3399 95.8575 95.1377 95.8575 93.6582V92.0367C95.8575 92.0323 95.8553 92.0257 95.8553 92.0225H90.4668Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8909 92.0234C90.8887 92.0267 90.8887 92.0311 90.8887 92.0354V93.4036C90.8887 94.6506 91.9062 95.6628 93.1619 95.6628C94.4166 95.6628 95.4341 94.6506 95.4341 93.4036V92.0234H90.8909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.39062,
    height: 1.57675,
    transform: "matrix(1 0 0 -1 90.4668 93.5996)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5449 92.0225V93.6582C97.5449 95.1377 98.7513 96.3399 100.239 96.3399C101.728 96.3399 102.933 95.1377 102.933 93.6582V92.0225H97.5449Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9688 92.0234V93.4036C97.9688 94.6506 98.9863 95.6628 100.24 95.6628C101.497 95.6628 102.514 94.6506 102.514 93.4036V92.0234H97.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38846,
    height: 1.57784,
    transform: "matrix(-1 0 0 1 102.929 92.0215)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.625 92.0225V93.6582C104.625 95.1377 105.831 96.3399 107.319 96.3399C108.809 96.3399 110.015 95.1377 110.015 93.6582V92.0225H104.625Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.047 92.0234V93.4036C105.047 94.6506 106.064 95.6628 107.318 95.6628C108.575 95.6628 109.592 94.6506 109.592 93.4036V92.0234H105.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38853,
    height: 1.57675,
    transform: "matrix(1 0 0 -1 104.626 93.5996)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.704 92.0225V93.6582C111.704 95.1377 112.91 96.3399 114.397 96.3399C115.885 96.3399 117.093 95.1377 117.093 93.6582V92.0367C117.093 92.0323 117.09 92.0257 117.09 92.0225H111.704Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.127 92.0234V93.4036C112.127 94.6506 113.145 95.6628 114.398 95.6628C115.653 95.6628 116.672 94.6506 116.672 93.4036V92.0354C116.672 92.0311 116.67 92.0267 116.67 92.0234H112.127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38853,
    height: 1.57784,
    transform: "matrix(-1 0 0 1 117.089 92.0215)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.784 92.0225C118.784 92.0257 118.782 92.0323 118.782 92.0367V93.6582C118.782 95.1377 119.991 96.3399 121.478 96.3399C122.965 96.3399 124.171 95.1377 124.171 93.6582V92.0225H118.784Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.206 92.0234V93.4036C119.206 94.6506 120.223 95.6628 121.477 95.6628C122.732 95.6628 123.748 94.6506 123.748 93.4036V92.0234H119.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38629,
    height: 1.57784,
    transform: "matrix(-1 0 0 1 124.17 92.0215)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1221 111.651V110.018C48.1221 108.536 49.3284 107.336 50.8158 107.336C52.3054 107.336 53.5107 108.536 53.5107 110.018V111.651H48.1221Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.542 111.651V110.273C48.542 109.024 49.5595 108.012 50.8142 108.012C52.0699 108.012 53.0874 109.024 53.0874 110.273V111.651H48.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38853,
    height: 1.57785,
    transform: "matrix(-1 0 0 1 53.5068 110.074)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2003 111.651C55.2003 111.648 55.1992 111.644 55.1992 111.639V110.018C55.1992 108.536 56.4067 107.336 57.894 107.336C59.3825 107.336 60.5889 108.536 60.5889 110.018V111.651H55.2003Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.623 111.651V110.273C55.623 109.024 56.6395 108.012 57.8941 108.012C59.1498 108.012 60.1674 109.024 60.1674 110.273V111.641C60.1674 111.643 60.1652 111.648 60.1652 111.651H55.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38853,
    height: 1.57784,
    transform: "matrix(1 0 0 -1 55.2012 111.651)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2784 111.651C62.2784 111.648 62.2773 111.644 62.2773 111.639V110.018C62.2773 108.536 63.4848 107.336 64.9732 107.336C66.4606 107.336 67.668 108.536 67.668 110.018V111.639C67.668 111.644 67.6669 111.648 67.6669 111.651H62.2784Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7013 111.651C62.7002 111.648 62.7002 111.643 62.7002 111.641V110.273C62.7002 109.024 63.7188 108.012 64.9724 108.012C66.2271 108.012 67.2457 109.024 67.2457 110.273V111.641C67.2457 111.643 67.2446 111.648 67.2446 111.651H62.7013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38958,
    height: 1.57785,
    transform: "matrix(-1 0 0 1 67.6699 110.074)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3564 111.651V110.018C69.3564 108.536 70.565 107.336 72.0524 107.336C73.5408 107.336 74.7461 108.536 74.7461 110.018V111.651H69.3564Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7794 111.651C69.7783 111.648 69.7783 111.643 69.7783 111.641V110.273C69.7783 109.024 70.797 108.012 72.0516 108.012C73.3062 108.012 74.3238 109.024 74.3238 110.273V111.651H69.7794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38847,
    height: 1.57784,
    transform: "matrix(1 0 0 -1 69.3574 111.651)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4355 111.651V110.018C76.4355 108.536 77.6419 107.336 79.1293 107.336C80.6188 107.336 81.8241 108.536 81.8241 110.018V111.651H76.4355Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8584 111.651V110.273C76.8584 109.024 77.876 108.012 79.1306 108.012C80.3864 108.012 81.4039 109.024 81.4039 110.273V111.651H76.8584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38853,
    height: 1.57785,
    transform: "matrix(-1 0 0 1 81.8311 110.074)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5166 111.651V110.018C83.5166 108.536 84.723 107.336 86.2092 107.336C87.6977 107.336 88.9051 108.536 88.9051 110.018V111.651H83.5166Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9375 111.651V110.273C83.9375 109.024 84.955 108.012 86.2075 108.012C87.4632 108.012 88.4818 109.024 88.4818 110.273V111.641C88.4818 111.643 88.4796 111.648 88.4796 111.651H83.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38846,
    height: 1.57785,
    transform: "matrix(-1 0 0 1 88.9014 110.074)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.595 111.651C90.595 111.648 90.5928 111.644 90.5928 111.639V110.018C90.5928 108.536 91.8013 107.336 93.2887 107.336C94.7761 107.336 95.9814 108.536 95.9814 110.018V111.651H90.595Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0178 111.651C91.0178 111.648 91.0156 111.643 91.0156 111.641V110.273C91.0156 109.024 92.0354 108.012 93.2889 108.012C94.5435 108.012 95.5611 109.024 95.5611 110.273V111.651H91.0178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38629,
    height: 1.57785,
    transform: "matrix(-1 0 0 1 95.9824 110.074)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6719 111.651V110.018C97.6719 108.536 98.8782 107.336 100.368 107.336C101.856 107.336 103.062 108.536 103.062 110.018V111.651H97.6719Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0969 111.651C98.0969 111.648 98.0947 111.643 98.0947 111.641V110.273C98.0947 109.024 99.1145 108.012 100.368 108.012C101.623 108.012 102.64 109.024 102.64 110.273V111.651H98.0969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38853,
    height: 1.57784,
    transform: "matrix(1 0 0 -1 97.6729 111.651)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.752 111.651V110.018C104.752 108.536 105.958 107.336 107.447 107.336C108.935 107.336 110.14 108.536 110.14 110.018V111.651H104.752Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.174 111.651V110.273C105.174 109.024 106.191 108.012 107.447 108.012C108.702 108.012 109.719 109.024 109.719 110.273V111.651H105.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.3886,
    height: 1.57785,
    transform: "matrix(-1 0 0 1 110.145 110.074)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.832 111.651C111.832 111.648 111.83 111.644 111.83 111.639V110.018C111.83 108.536 113.039 107.336 114.526 107.336C116.016 107.336 117.221 108.536 117.221 110.018V111.651H111.832Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.253 111.651V110.273C112.253 109.024 113.27 108.012 114.525 108.012C115.781 108.012 116.798 109.024 116.798 110.273V111.651H112.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.38846,
    height: 1.57785,
    transform: "matrix(-1 0 0 1 117.216 110.074)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.909 111.651V110.018C118.909 108.536 120.116 107.336 121.605 107.336C123.092 107.336 124.3 108.536 124.3 110.018V111.651H118.909Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.334 111.651C119.332 111.648 119.332 111.643 119.332 111.641V110.273C119.332 109.024 120.351 108.012 121.605 108.012C122.86 108.012 123.879 109.024 123.879 110.273V111.641C123.879 111.643 123.876 111.648 123.876 111.651H119.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.3907,
    height: 1.57784,
    transform: "matrix(1 0 0 -1 118.908 111.651)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6626 42.108C99.5895 44.0724 101.15 45.6246 103.149 45.8186C104.709 45.9884 107.538 45.1153 110.878 44.2422C114.998 43.1751 119.898 42.108 124.043 42.9811C112.828 38.2518 105.392 38.7126 103.393 38.6398C103.368 38.6398 103.32 38.6398 103.271 38.6398C101.345 38.6398 99.7358 40.1678 99.6626 42.108Z",
    fill: "url(#paint8_linear_14011_164662)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.115 38.6399C66.1158 38.7127 58.6798 38.2519 47.4648 42.9811C51.6095 42.108 56.5099 43.1751 60.6302 44.2422C63.9703 45.1153 66.7985 45.9884 68.3588 45.8187C70.358 45.6246 71.9183 44.0725 71.8452 42.108C71.772 40.1678 70.1629 38.6399 68.2369 38.6399C68.1881 38.6399 68.1394 38.6399 68.115 38.6399Z",
    fill: "url(#paint9_linear_14011_164662)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14011_164662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.2653 92.2127) rotate(90) scale(33.5156 54.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40414,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681066,
    stopColor: "#EC8F3A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8F3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14011_164662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.3132 66.9781) scale(15.6295 15.5476)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14011_164662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.3149 66.9786) scale(8.40804 8.36398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#73B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14011_164662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.3099 70.4385) rotate(-90) scale(11.169 14.5336)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#2E2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E2A49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#B0C5FB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14011_164662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.205 66.9778) scale(15.6298 15.548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_14011_164662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.205 66.9785) scale(8.40804 8.36398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#73B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_14011_164662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.2 70.4385) rotate(-90) scale(11.169 14.5336)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#2E2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E2A49",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#B0C5FB",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14011_164662",
    x1: 38.807,
    y1: 112.244,
    x2: 38.807,
    y2: 91.9102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14011_164662",
    x1: 99.6626,
    y1: 30.115,
    x2: 124.043,
    y2: 30.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14011_164662",
    x1: 71.8452,
    y1: 30.1151,
    x2: 47.4648,
    y2: 30.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14011_164662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 147,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterHandsUp4);
export default __webpack_public_path__ + "static/media/MonsterHandsUp4.e5eb80b3d4ea54c231695daa1810b930.svg";
export { ForwardRef as ReactComponent };